import React from 'react';

// components
import { Button, Card, CardBody, CardFooter, Row, Col } from "reactstrap";

// helpers
import { formateDate } from '../../../helpers/formats';

export default function VistoriaOnlineListaBoletinsVinculados({ boletinsVinculados }) {

    return (
        <>
            <Row>
                {boletinsVinculados && boletinsVinculados.map((m, key) => (
                    <Col lg="4" md="6" sm="12" key={key}>
                        <Card className="mt-4">
                            <CardBody>
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <h5 className="subtitleCard">{formateDate(m.dataVistoria)}</h5>
                                    </Col>
                                    <Col lg="12" md="12" sm="12">
                                        <strong>Fiscal: </strong><span>{m.usuarioFiscal_Nome}</span>
                                    </Col>
                                    <Col lg="12" md="12" sm="12">
                                        <strong>Situação Análise: </strong><span>{m.situacaoAnalise}</span>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter className="text-center">
                                <Button className="btn-link text-info" onClick={() => window.open("/empty/impressaovistoria?codigo=" + m.boletimVistoria_Id, "blank")}>
                                    <i className="fas fa-search"></i> Visualizar Boletim
                                </Button>
                            </CardFooter>
                        </Card>
                    </Col>
                ))}
            </Row>
        </>
    );
}

